<script>
  import { onMount, onDestroy } from 'svelte';
  import Chart from 'chart.js/auto';

  export let title = '';
  export let data = [];
  export let labels = [];
  export let colors = ['#3B82F6', '#60A5FA', '#93C5FD'];

  let chartCanvas;
  let chart;

  onMount(() => {
    if (!chartCanvas) return;

    const ctx = chartCanvas.getContext('2d');

    chart = new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: labels,
        datasets: [{
          data: data,
          backgroundColor: colors,
          borderWidth: 0,
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          }
        },
        cutout: '70%',
      }
    });
  });

  onDestroy(() => {
    if (chart) {
      chart.destroy();
    }
  });

  $: if (chart && data && labels) {
    chart.data.labels = labels;
    chart.data.datasets[0].data = data;
    chart.data.datasets[0].backgroundColor = colors;
    chart.update();
  }
</script>

<div class="bg-white rounded-lg border border-gray-200 p-6">
  <h3 class="text-lg font-semibold text-gray-900 mb-4">{title}</h3>

  <div class="flex items-center justify-between">
    <div style="height: 200px; width: 200px;">
      <canvas bind:this={chartCanvas}></canvas>
    </div>

    <div class="flex flex-col gap-3">
      {#each labels as label, idx}
        <div class="flex items-center gap-2">
          <div class="w-3 h-3 rounded-full" style="background-color: {colors[idx]}"></div>
          <span class="text-sm text-gray-700">{label}</span>
        </div>
      {/each}
    </div>
  </div>
</div>
